import { Component, OnInit, AfterViewInit } from "@angular/core";

import { Store, StoreModule } from "@ngrx/store";
import { Observable, map } from "rxjs";

import { VerticalComponent } from "./vertical/vertical.component";
import { TranslateService } from "@ngx-translate/core";
import { LayoutSettings } from "../core/helpers/layout-settings";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: [],
  standalone: true,
  imports: [VerticalComponent],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  // layout related config
  layoutType: string;
  layoutwidth: string;
  topbar: string;
  mode: string;
  sidebartype: string;
  layoutSettings: any;
  dataLayout$: Observable<string>;

  constructor() {}

  ngOnInit() {
    // Get the layout settings
    this.layoutSettings = LayoutSettings.getLayoutSettings();

    // default settings
    document.body.setAttribute(
      "data-bs-theme",
      this.layoutSettings.LAYOUT_MODE_TYPES,
    );
    document.body.setAttribute(
      "data-layout-size",
      this.layoutSettings.LAYOUT_WIDTH_TYPES,
    );
    document.body.setAttribute(
      "data-sidebar",
      this.layoutSettings.SIDEBAR_TYPE,
    );
    document.body.setAttribute(
      "data-topbar",
      this.layoutSettings.TOPBAR_MODE_TYPES,
    );

    // SIDEBAR_MODE
    document.body.setAttribute("data-sidebar", "dark");
    document.body.removeAttribute("data-topbar");
    document.body.removeAttribute("data-layout-size");
    document.body.removeAttribute("data-keep-enlarged");
    document.body.removeAttribute("data-sidebar-size");
    document.body.classList.remove("sidebar-enable");
    document.body.classList.remove("vertical-collpsed");
    document.body.removeAttribute("data-layout-scrollable");

    // LAYOUT_WIDTH
    document.body.setAttribute("data-layout-size", "fluid");
    document.body.classList.remove("vertical-collpsed");
    document.body.removeAttribute("data-layout-scrollable");
  }

  ngAfterViewInit() {}

  /**
   * Check if the vertical layout is requested
   */
  isVerticalLayoutRequested() {
    this.dataLayout$.subscribe((dataLayout) => {
      document.body.setAttribute("data-layout", dataLayout);
    });
  }
}
